
    import '/builds/1N4HJJhF/0/wepie-ee/fe/fe-base/weet-components/site/docs/weet/antd.md?watch=parent';
    export const demoIndex = {
  ids: ["docs-weet-antd-demo-basic"],
  getter: () => import(/* webpackChunkName: "meta__docs" */'/builds/1N4HJJhF/0/wepie-ee/fe/fe-base/weet-components/site/docs/weet/antd.md?type=demo')
};